import { Link } from "react-router-dom";

const About = () => {

  const products = [
    { id: 1, name: "Piperine extract ", img: "/images/piperine.png" },
    { id: 2, name: "Kutki root extract ", img: "/images/Kutki_root_extract.png" },
    { id: 3, name: "Green coffee", img: "images/greencofee.png" },
{ id: 4, name: "Saffron extract", img: "images/safron_extract.png" },  ];

  return (
    <>



   

      
      {/* ABOUT SECTION */}
      <div id="about" className="px-4 md:px-10 py-8 md:py-12">
        
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl md:text-2xl font-bold mb-4 text-center md:text-left">
            About Us
          </h2>

          <p className="text-sm md:text-base leading-relaxed text-gray-700 text-center md:text-left">
        Aranya Nutraceuticals was created with a simple thought—to keep things as close to nature as possible. We work with plant-based materials that are sourced with care and handled in their most natural form.
Today, speed and volume often take priority over purity. This shift is slowly impacting both the environment and the quality of what we use every day.
We focus on doing things differently—keeping sourcing simple, maintaining consistency, and respecting the natural value of every raw material.
Aranya Nutraceuticals stands for honesty in what we offer—clean, natural, and dependable.

We focus on supplying naturally sourced raw materials and plant-based extracts for industrial use. Our approach is simple—maintain quality, ensure consistency, and build reliable sourcing connections.
          </p>
        </div>

        {/* Why Us */}
        <div className="max-w-5xl mx-auto mt-8 md:mt-10">
          <h3 className="text-lg md:text-xl font-semibold mb-3 text-center md:text-left">
            Why Us
          </h3>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3 text-sm md:text-base text-gray-700">
            <li>✔ Reliable sourcing network</li>
            <li>✔ Supply of both raw materials and extracts</li>
            <li>✔ Consistent quality focus</li>
            <li>✔ Flexible requirements handling</li>
            <li>✔ Timely response and support</li>
            <li>✔ Pan-India B2B supply</li>
          </ul>
        </div>
      </div>

      {/* PRODUCTS PREVIEW (ONLY 4) */}
      
    </>
  );
};

export default About;